import { render, staticRenderFns } from "./DashboardPanel.vue?vue&type=template&id=13409d36&scoped=true"
import script from "./DashboardPanel.vue?vue&type=script&lang=js"
export * from "./DashboardPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13409d36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13409d36')) {
      api.createRecord('13409d36', component.options)
    } else {
      api.reload('13409d36', component.options)
    }
    module.hot.accept("./DashboardPanel.vue?vue&type=template&id=13409d36&scoped=true", function () {
      api.rerender('13409d36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/DashboardPanel.vue"
export default component.exports